<div class="flex overflow-x-auto user-select-none w-full" [attr.data-cy]="'ui-tabs'">
	@for (tab of tabs(); track tab.key; let i = $index) {
		<button
			class="line-clamp-1 flex cursor-pointer items-center grow font-semibold h-10 justify-center min-w-40 px-6 whitespace-nowrap focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-focus focus-visible:z-10"
			[tabindex]="getTabTabIndex(i)"
			[attr.data-cy]="'ui-tabs-' + tabs()[i].key + (i === selectedIndex() ? '-active' : '')"
			[class]="{
				'bg-primary-100': !tab.disabled && !tab.warning && i !== selectedIndex(),
				'bg-primary-300': !tab.disabled && !tab.warning && i === selectedIndex(),
				'bg-[var(--color-docs-primary-100)]': !tab.disabled && tab.warning && i !== selectedIndex(),
				'bg-[var(--color-docs-primary-300)]': !tab.disabled && tab.warning && i === selectedIndex(),
				'bg-secondary-100': tab.disabled,
				'text-secondary-400': tab.disabled,
				'cursor-not-allowed': tab.disabled,
			}"
			(click)="tabChanged(i)"
			(keydown)="onKeyDown($event, i)"
			(focus)="onFocus(i)"
		>
			{{ tab.translation }}
			@if (tab.icon) {
				<ui-icon
					icon="o_info"
					size="m"
					class="ml-1"
					[uiTooltip]="tab.tooltipMessage ?? ''"
					[tooltipOnMobile]="true"
				></ui-icon>
			}
			@if (tab.warning) {
				<ui-icon class="ml-1" data-cy="ui-tabs-warning" [icon]="warningIcon" size="m"></ui-icon>
			}
		</button>
	}
</div>
